import { MainTitle } from '../../styles/page.styles';

const AuctionsPage = () => {
    return (
        <MainTitle>Auctions</MainTitle>
    )
}

export default AuctionsPage;